
/**
 * appUiCoreShipMethodRulesRepository
 */
angular.module('app-ui-ship-method-rules').service(
    'appUiCoreShipMethodRulesRepository',
    [
        'pipeRatApiRepositoryService',
        function (
            pipeRatApiRepositoryService
        ) {
            return pipeRatApiRepositoryService.getNewRepository(
                '/api/resource/ship-method-rules',
                'appUiCoreShipMethodRulesRepository'
            );
        },
    ]
);
